import styled from 'styled-components'
import { color } from 'styles/global'

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  height:100%;
  /* background : ${color.ROOM_COLOR}; */
  display:flex;
  flex-direction:column;
  height: 100vh;
`
